import { toast, ToastOptions } from 'react-toastify';
import { AXIcon } from '../icons';
import { ReactNode } from 'react';
import I18nWrapper from '../../i18n/i18n-wrapper';
import { v4 as uuidv4 } from 'uuid';

interface AlertToastsProps {
  type: 'success' | 'warning' | 'error' | 'info' | 'dark';
  translateKey?: string;
  content?: ReactNode;
  toastId?: string;
  ns?: string;
  options?: any;
}

const getToastId = (toastId?: string) => toastId || uuidv4();

const alertToast = ({
  type = 'warning',
  translateKey,
  content,
  toastId,
  options,
}: AlertToastsProps) => {
  const getContent = () => {
    if (translateKey) {
      return (
        <span className="font-intrum text-xl font-medium">
          <I18nWrapper translateKey={translateKey} options={options} />
        </span>
      );
    }
    if (content) {
      return content;
    }
    return <></>;
  };

  const configuration: ToastOptions<unknown> = {
    autoClose: 5000,
    closeOnClick: true,
    closeButton: false,
    theme: 'light',
    toastId: getToastId(toastId),
    hideProgressBar: true,
    bodyClassName: 'flex items-center gap-2 px-2',
  };

  switch (type) {
    case 'warning':
      return toast.warning(getContent(), {
        ...configuration,
        icon: <AXIcon className="text-yellow-500" icon="Shield" />,
        className:
          'bg-yellow-100/90! backdrop-blur border-l-20 border-yellow-500! text-gray-900!',
      });
    case 'error':
      return toast.error(getContent(), {
        ...configuration,
        icon: <AXIcon className="text-red-500" icon="Warning" />,
        className:
          'bg-red-100/90! backdrop-blur border-l-20 border-red-500 text-red-500!',
      });
    case 'success':
      return toast.success(getContent(), {
        ...configuration,
        icon: <AXIcon className="text-green-500 mr-2" icon="Verified" />,
        className:
          'bg-green-100/90! backdrop-blur border-l-20 border-green-500 text-green-600!',
      });
    case 'info':
      return toast.info(getContent(), {
        ...configuration,
        icon: <AXIcon className="text-blue-600" icon="Sparkles" />,
        className:
          'bg-blue-200/85! backdrop-blur border-l-20 border-blue-500! text-blue-600!',
      });
    default:
      return toast(getContent(), {
        ...configuration,
        className: 'toast-bg-blur',
      });
  }
};
export default alertToast;
